
import location from './location';
import steps from './steps';
import company from './company';
import creative from './creative';
import payment from './payment';

// Adding missing translations that weren't included in the imported modules
const additionalTranslations = {
  // Campaign types
  standard: "Standard Campaign",
  premium: "Premium Campaign",
  enterprise: "Enterprise Campaign",
  
  // Campaign creation
  newCampaign: "Launch Your Campaign",
  startFreshCampaign: "Enhance Your Brand Presence",
  createCampaignCard: "Targeted advertisements that deliver ROI. Reach the right audience and boost conversions through our strategic digital platform.",
  createCampaign: "Create Campaign",
  
  // Campaign name
  campaignName: "Campaign Name",
  enterCampaignName: "Enter campaign name",
  campaignNameHelp: "Choose a descriptive name to easily identify your campaign",
  nameCampaign: "Name Your Campaign",
  nameCampaignDescription: "Provide a unique identifier for your marketing initiative",
  
  // Campaign fields
  campaignTitle: "Campaign Title",
  campaignDescription: "Campaign Description",
  campaignBudget: "Budget Allocation",
  campaignStart: "Start Date",
  campaignEnd: "End Date",
  
  // Campaign statuses
  draft: "Draft",
  pending: "Pending Approval",
  active: "Active",
  completed: "Completed",
  cancelled: "Cancelled",
  
  // Campaign metrics
  impressions: "Impressions",
  reach: "Audience Reach",
  engagement: "Engagement Rate",
  conversion: "Conversion Rate",
  roi: "Return on Investment",
  
  // Drafts section
  savedDrafts: "Saved Campaigns",
  noDrafts: "No saved campaigns found",
  createYourFirst: "Create your first campaign",
  lastEdited: "Last edited",
  actions: "Actions",
  viewAll: "View all campaigns",
  loading: "Loading...",

  // Draft resume section
  resumeDraft: "Resume Your Campaign",
  continuePreviousDraft: "Continue previously saved campaigns",
  viewAllDrafts: "View all saved campaigns",
  noDraftsFound: "No campaigns in progress",
  loadingDrafts: "Loading...",
  draftDeleted: "Campaign removed",
  draftDeletedSuccess: "Campaign successfully removed",
  errorDeletingDraft: "Error removing campaign",
  problemDeletingDraft: "There was a problem removing your campaign",
  confirmDeleteDraft: "Confirm Removal",
  cancel: "Cancel",
  delete: "Remove",
  
  // Client dashboard section
  clientDashboard: "Client Dashboard",
  manageYourCampaigns: "Monitor and manage your active campaigns",
  viewCampaignPerformance: "Access analytics, track performance metrics, and optimize your marketing efforts through our comprehensive dashboard.",
  accessDashboard: "Access Dashboard",

  // Step wizard descriptions
  enterAccountInfoDesc: "Enter your company and contact information",
  selectLocationDesc: "Choose the locations for your campaign",
  selectDurationDesc: "Choose how long you want your campaign to run",
  uploadCreativesDesc: "Upload your creative assets for the campaign",
  reviewCampaignDesc: "Review your campaign details",

  // Saving
  saving: "Saving...",
  startCampaign: "Start Campaign",
  
  // Dashboard
  campaignDashboard: "Campaign Dashboard",
};

export default {
  ...location,
  ...steps,
  ...company,
  ...creative,
  ...payment,
  ...additionalTranslations,
} as const;
